import { render, staticRenderFns } from "./EcommDashboardErrorModal.vue?vue&type=template&id=74be31a5"
import script from "./EcommDashboardErrorModal.vue?vue&type=script&lang=js"
export * from "./EcommDashboardErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports